export default __webpack_public_path__ + "static/media/card-error.1e0c7706.svg";